export const getDoctorsFrag = `
    id
    name
    surname
    titleBeforeName
    titleAfterName
    email
    icpOfDoctor
    image
    sex
`;
